// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"5ed41441","404":"1bc26178","498":"312b0e77"}[chunkId] + ".chunk.js";
};